const getResourcesByType = (resources, resourceType) =>
  resources.filter(({ __typename }) => __typename === resourceType);

const getCourseOutlineResourcesByType = (units = [], resourceType) => {
  let resources = [];
  units.forEach((unit) => {
    const { resources: unitResources, subunits } = unit;

    if (unitResources && unitResources.length) {
      const _resources = getResourcesByType(unitResources, resourceType);
      if (_resources.length) {
        resources = resources.concat(
          _resources.map((resource) => ({
            ...resource,
            unitId: unit.unitId,
            subunitId: null,
          })),
        );
      }
    }

    subunits.forEach((subunit) => {
      const { resources: subunitResources } = subunit;
      if (subunitResources && subunitResources.length) {
        const _resources = getResourcesByType(subunitResources, resourceType);
        if (_resources.length) {
          resources = resources.concat(
            _resources.map((resource) => ({
              ...resource,
              unitId: unit.unitId,
              subunitId: subunit.subunitId,
            })),
          );
        }
      }
    });
  });

  return resources;
};

export default getCourseOutlineResourcesByType;
